module.exports = __webpack_public_path__ + "fonts/Gibson-Italic.af6d3584.woff2";